export default {"src":"/_next/static/media/spon.5fea9e82.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};